<div class="statut-main-row">
  <span [class]="'status-badge ' + statusClass()">
    <span class="status-badge-dot" [style.background]="statusColor()" aria-hidden="true"></span>
    {{ statusText() || 'Indisponible' }}
  </span>

  <span
    class="loss-metric"
    role="img"
    aria-label="Perte : donnée indisponible"
    title="Perte : donnée indisponible"
  >
    <span class="loss-icon" aria-hidden="true">€</span>
    <span aria-hidden="true">—</span>
  </span>

  <p class="last-update">
    <span>Dernière mise à jour</span>
    @if (derniereMiseAJourDate(); as date) {
      <time [attr.datetime]="date.toISOString()"
        >le {{ jourFormate() }} à {{ heureFormatee() }}</time
      >
    } @else {
      <span>Non renseignée</span>
    }
  </p>
</div>
